import styled from 'styled-components';

export const Container = styled.div`
  button:disabled {
    cursor: not-allowed;
  }
`;
